import Categories from './Categories.container';

export default Categories;
